/** @format */
import { post, download } from '@root/utils/httpWrap';

function transformParam(p: any) {
  return {
    ...p,
    userId: ''
  };
}

/**
 * 僵尸车查询
 */
export const queryOrderCleanList = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/orderClean/list', transformParam(params));
};

/**
 * 僵尸车清理
 */
export const clenMultiOrder = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/orderClean/batchClean', transformParam(params));
};

/**
 * 僵尸车清理记录查询
 */
export const queryOrderCleanRecordList = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/orderCleanRecord/list', transformParam(params));
};

/**
 * 僵尸车清理记录导出
 * @param params
 */
export const exportOrderCleanRecord = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/orderCleanRecord/export', transformParam(params), fileName);
};

/**
 * 手动抬杠记录查询
 * @param params
 */
export const queryOrderHandLiftRecord = (params: any): any => {
  return post('bangdao/saasapi/v1/orderHandLift/list', transformParam(params));
};

/**
 * 手动抬杆记录导出
 * @param params
 */
export const exportHandLiftRecord = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/orderHandLift/export', transformParam(params), fileName);
};

/**
 * 手动抬杆审核
 * @param params
 */
export const orderHandLiftExamine = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderHandLift/examine', transformParam(params));
};

/**
 * 特殊放行查询
 * @param params
 */
export const queryOrderSpecialRecord = (params: any): any => {
  return post('bangdao/saasapi/v1/orderSpecial/list', transformParam(params));
};

/**
 * 特殊放行审核
 * @param params
 */
export const orderSpecialExamine = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderSpecial/examine', transformParam(params));
};

/**
 * 特殊放行导出
 * @param params
 */
export const orderSpecialRecordExport = (params: any, fileName?: string): any => {
  console.log('file name--:', fileName);
  return download('bangdao/saasapi/v1/orderSpecial/export', transformParam(params), fileName);
};

/**
 * 车辆修正记录查询
 */
export const queryRepaireRecord = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/orderRevise/list', transformParam(params));
};

/**
 * 车辆修正审核
 * @param params
 */
export const repaireRecordExamine = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderRevise/examine', transformParam(params));
};

/**
 * 车辆修正导出
 * @param params
 */
export const repaireRecordExport = (params: any, fileName?: string): any => {
  console.log('file name--:', fileName);
  return download('bangdao/saasapi/v1/orderRevise/export', transformParam(params), fileName);
};

/**
 * 应收未收记录查询
 */
export const queryOrderUncollectedRecord = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/orderUncollected/list', transformParam(params));
};

/**
 * 应收未收记录审核
 * @param params
 */
export const orderUncollectedExamine = (params: any): any => {
  return post('/bangdao/saasapi/v1/orderUncollected/payBack', transformParam(params));
};

/**
 * 应收未收记录导出
 * @param params
 */
export const orderUncollectedExport = (params: any, fileName?: string): any => {
  console.log('file name--:', fileName);
  return download('bangdao/saasapi/v1/orderUncollected/export', transformParam(params), fileName);
};

/**
 * 判断出场或在场
 * 00：在场，01：离场，null：订单不存在
 * @param params
 */
export const enterOrExit = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/orderHandLift/enterOrExit', transformParam(params));
};

/**
 * 异常原因设置查询
 */

export const getEnumByParentId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/enum/getEnumByParentId', params);
};

/**
 * 异常原因设置新增编辑
 */

export const addOrEditStord = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/enum/addOrEdit', params);
};

/**
 * 异常原因设置详情回显
 */

export const editInfo = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/enum/editInfo', params);
};

// 通道列表
export const infoParkChannelList = (params: any): any => {
  return post('bangdao/saasapi/v1/flow/infoParkChannelList', params);
};
